import JQueryView, { on } from '../../../../../../common/views/jqueryView';
import $ from 'jquery';

export default class ConfirmView extends JQueryView {
  constructor() {
    super('.my.investors.specific_applications.corporates.confirm');

    this.render();
  }

  @on({ event: 'change', selector: '#check-consent' })
  onChangeCheckConsent() {
    this.render();
  }

  @on({ event: 'change', selector: '#check-in-july' })
  onChangeCheckInJuly() {
    this.render();
  }

  render() {
    // 8月1日以降の更新のチェックボックスがなければチェック扱いとする
    const isCheckedInJuly =
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- チェック済みまたは要素なしを判定する
      $('#check-in-july').prop('checked') || $('#check-in-july').length === 0;

    if ($('#check-consent').prop('checked') && isCheckedInJuly) {
      $('#complete-link').prop('disabled', false);
    } else {
      $('#complete-link').prop('disabled', true);
    }
  }
}
